import { Loader2 } from "lucide-react";
import { createPortal } from "react-dom";
import { useIsMobile } from '@/core/hooks/useMediaQuery';

interface MergingPreVerifyDialogProps {
  phoneNumber: string;
  isOtpLoading: boolean;
  onSendOtp: () => void;
  handleLogout: () => void;
}

export function MergingPreVerifyDialog({
  phoneNumber,
  isOtpLoading,
  onSendOtp,
  handleLogout,
}: MergingPreVerifyDialogProps) {
  const isMobile = useIsMobile();

  return createPortal(
    <div className={`fixed inset-0 z-[60] bg-black/40 flex justify-center ${
        isMobile ? "items-end" : "items-center"
      }`}
    >
      <div className={`bg-white w-full flex flex-col shadow-xl transition-all transform ${
          isMobile 
            ? "rounded-t-2xl p-[20px] animate-in slide-in-from-bottom-4 duration-300 pt-[40px]" 
            : "max-w-lg rounded-md p-6 mx-4"
        }`}
      >
        <div className="flex flex-col justify-between items-start">
          <p className={`${isMobile ? 'text-lg' : 'text-xl'} font-semibold mb-2`}> 
            Verify your number +91 {phoneNumber} 
          </p>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          Your mobile number is not verified. Please click the button below to verify with an OTP to continue.
        </p>
        <div className={`flex gap-2 ${isMobile ? "flex-col-reverse flex-col" : "flex-row"}}`}>
            <button className={`${isMobile ? 'text-[#4a90e2]' : 'px-5 border border-gray'}`} onClick={handleLogout}>
                Logout
            </button>
            <button 
            onClick={onSendOtp}
            disabled={isOtpLoading}
            className={`w-full h-[50px] flex items-center justify-center bg-hover px-5 py-2 text-md bg-brand text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed`}
            >
            {isOtpLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Send OTP
            </button>
        </div>
      </div>
    </div>,
    document.body
  );
}